import React, { Component } from 'react'
import { Button, Col, Container, Dropdown, Modal, Row } from "react-bootstrap"
import { connect } from 'react-redux'
import { RouteComponentProps } from "react-router-dom"
import { AppState, WorkforceClinicPortal } from "../../AppState"

export interface PortalSelectionProps { }

export interface PortalSelectionAppStateProps {
  portals?: WorkforceClinicPortal[];
}

export class PortalSelectionModal extends Component<PortalSelectionProps & PortalSelectionAppStateProps & RouteComponentProps>{

  selectPortal = (portal: WorkforceClinicPortal) => {
    const link = portal.Link || portal.AssignedClientDetailsOfClinic[0]?.Link
    link && window.location.replace(link.split('#')[0])
  }

  render() {
    const portals = this.props.portals?.sort((a, b) => (a.ImplementationName || "").localeCompare(b.ImplementationName || "")) || []
    return <Modal backdrop="static" centered show={true}>
      <Modal.Header>
        <Modal.Title>Invalid Login</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container fluid>
          <Row>
            <Col>
              <h5>The username and password you entered do not belong to this portal.</h5>
              <p>Please try to login using the below portal.</p>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Dropdown>
          <Dropdown.Toggle variant="secondary">Select Portal</Dropdown.Toggle>
          <Dropdown.Menu className='secondary'>
            {portals.map((portal, i) => <Dropdown.Item as={Button}
              onClick={() => this.selectPortal(portal)}
              key={`${portal.ImplementationID}_${i}`}
              eventKey={`${portal.ImplementationID}_${i}`}
              variant="menu-item">
              {portal.ImplementationName}
            </Dropdown.Item>)}
          </Dropdown.Menu>
        </Dropdown>
      </Modal.Footer>
    </Modal>
  }
}

function mapStateToProps(state: AppState): PortalSelectionAppStateProps {
  return {
    portals: state.Workforce1Companies.visibleCompanies
  }
}

export default connect(mapStateToProps, null)(PortalSelectionModal)
